import { cn } from "@/lib/utils";
import { FrogAvatar } from "./FrogAvatar";

interface LilyPadProps {
  habitName: string;
  frogStage: "egg" | "tadpole" | "young" | "adult" | "hibernating";
  daysCompleted: number;
  currentStreak: number;
  onClick?: () => void;
  className?: string;
  style?: React.CSSProperties;
}

export const LilyPad = ({
  habitName,
  frogStage,
  daysCompleted,
  currentStreak,
  onClick,
  className,
  style,
}: LilyPadProps) => {
  return (
    <div
      onClick={onClick}
      className={cn(
        "relative cursor-pointer transition-all duration-300 hover:scale-110 group",
        className
      )}
      style={style}
    >
      {/* Lily pad base */}
      <div className="relative">
        <div className="w-28 h-24 bg-lily-pad rounded-[50%] shadow-float relative overflow-hidden">
          {/* Lily pad texture */}
          <div className="absolute inset-0 bg-gradient-to-br from-lily-pad to-primary/70" />
          <div className="absolute top-1/2 left-0 w-full h-0.5 bg-primary/30" />
          <div className="absolute top-0 left-1/2 w-0.5 h-full bg-primary/30" />
          
          {/* Cut in lily pad */}
          <div className="absolute bottom-0 left-1/2 -translate-x-1/2 w-3 h-12 bg-pond-surface rounded-t-full" />
        </div>

        {/* Frog on lily pad */}
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2">
          <FrogAvatar 
            stage={frogStage} 
            size="md" 
            daysCompleted={daysCompleted}
          />
        </div>
      </div>

      {/* Habit name tooltip */}
      <div className="absolute -bottom-10 left-1/2 -translate-x-1/2 opacity-0 group-hover:opacity-100 transition-all duration-200 z-10">
        <div className="bg-card text-foreground text-sm px-3 py-2 rounded-xl shadow-float whitespace-nowrap">
          <p className="font-semibold">{habitName}</p>
          <p className="text-xs text-muted-foreground">
            {daysCompleted} dias • {currentStreak} 🔥
          </p>
        </div>
      </div>
    </div>
  );
};
